export default "__VITE_ASSET__CYlGuZj___"